module.exports = __webpack_public_path__ + "img/logo02.7476d5d9.svg";